<div class="porfolio-properties-wrapper">
  <div *ngIf="showTitleInfo">
    <h2>{{'raci.portfolioProperties.argusPushTitle' | translate | uppercase}}</h2>
    <p>{{'raci.portfolioProperties.argusPushSubTitle' | translate}}</p>
  </div>
  <div class="argus-sync-header">
    <p class="valorem-table-header">Publish Status</p>
    <table class="argus-properties-table" aria-hidden="true">
      <tr class="argus-table-content">
        <td class="argus-content-title"> {{'raci.argusSyncInfo.lastSyncStatus' | translate}}</td>
        <td class="argus-content-title">{{lastSyncInfo.dataStatus}}</td>
        <td class="argus-content-title"> {{'raci.argusSyncInfo.portfolioId' | translate}}</td>
        <td class="argus-content-title">{{lastSyncInfo.argusPortfolioId}}</td>
      </tr>
      <tr class="argus-table-content">
        <td class="argus-content-title">{{'raci.argusSyncInfo.lastSync' | translate}}</td>
        <td class="argus-content-title">{{lastSyncInfo.lastDataSync | date: 'dd/MM/YYYY HH:mm'}}</td>
        <td class="argus-content-title"> {{'raci.argusSyncInfo.propertiesSynced' | translate}}</td>
        <td class="argus-content-title"> <div *ngIf="lastSyncInfo.dataStatus !== 'NOT SYNCED'"> {{numberOfSyncProp}} </div> </td>
      </tr>
      <tr class="argus-table-content">
        <td class="argus-content-title">{{'raci.argusSyncInfo.syncBy' | translate}}</td>
        <td class="argus-content-title">{{lastSyncInfo.syncBy}}</td>
      </tr>
    </table>
  </div>
  <div class="porfolio-properties-body">
    <div class="porfolio-properties-project">
      <svg-icon src='./assets/icons/icon-by-region-default.svg'
                title="{{'raci.participantsAssignment.participants' | translate | uppercase}}"
                class="menu-action-icon svg-icon-red" align='center'>
      </svg-icon>
      <div *ngIf="allowSync && activeTask?.taskActionStage === ActionStageEnum.Waiting " [formGroup]="syncOptionsForm" class="radio-group">
        <label class="d-block pb-15 pt-35" *ngIf="!shouldDisplayCreateArgusPortfolio">
          <input type="radio" [value]="ArgusSyncOptionEnum.NewValuation" formControlName="option" (change)="selectAllProperties()">
          <span>{{'raci.argusSyncInfo.pushNewPortfolio' | translate}}</span>
        </label>
        <label class="d-block pb-15 pt-35" *ngIf="shouldDisplayCreateArgusPortfolio">
          <input type="radio" [value]="ArgusSyncOptionEnum.UpdateValuation" formControlName="option" (change)="selectAllProperties()">
          <span>{{'raci.argusSyncInfo.pushUpdatePortfolio' | translate}}</span>
        </label>
        <label class="d-block pb-15" [class.disabled-label]="!activePortfolioSourceValuationEventId" *ngIf="!shouldDisplayCreateArgusPortfolio">
          <input type="radio" [value]="ArgusSyncOptionEnum.CopyOfExistingValuation" formControlName="option" (change)="selectAllProperties()">
          <span>{{'raci.argusSyncInfo.pushCopy' | translate}}</span>
        </label>
      </div>
    </div>
    <div class="portfolio-properties">
      <div class="properties-content">
        <kendo-grid [data]="properties"
                    #raciParticipantsGrid
                    (cellClick)="onCellSelection($event)"
                    class="kendo-white-grid approval-grid custom-participants-grid"
                    [selectable]="selectableSettings"
                    *ngIf="!groupBy">
          <kendo-grid-column [headerClass]="'participants-grid'" field="propertyName"
                             title="{{'raci.participantsAssignment.propertyName' | translate}}"
                             [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="municipally"
                             title="{{'raci.participantsAssignment.titleMunicipally' | translate}}"
                             [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="address"
                             title="{{'raci.participantsAssignment.titleAddress' | translate}}"
                             [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="argusPropAssetId"
                             title="{{'raci.participantsAssignment.argusPropAssetId' | translate}}"
                             [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="dataStatus"
                             title="{{'raci.participantsAssignment.dataStatus' | translate}}"
                             [width]="auto">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div (click)="getLastSyncLogs(dataItem)" class="argus-sync-data-status">{{dataItem.dataStatus }}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="lastDataSync"
                             title="{{'raci.participantsAssignment.lastDataSync' | translate}}"
                             [width]="auto">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{dataItem.lastDataSync | date: 'dd/MM/YYYY HH:mm'}}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
        <div *ngIf="groupBy">
          <div class="spacing-bottom-5" *ngFor="let item of groupData">
            <kendo-grid [data]="item.approvals"
                        class="kendo-white-grid group-header"
                        (cellClick)="onRowSelection($event)"
                        [hideHeader]="true">
              <kendo-grid-column [headerClass]="'participants-grid group-name'"
                                 field="project"
                                 title="project"
                                 class="fill-line"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="group-name-wrapper">
                    <h4 class="properties-name">{{item.group}}</h4>
                    <div class="dashed-bottom"></div>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid fill-line'"
                                 field="line"
                                 title="line"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="dashed-bottom"></div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid fill-line'"
                                 field="line"
                                 title="line"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="dashed-bottom"></div>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
            <kendo-grid [data]="item.tasks"
                        #raciParticipantsGrid
                        class="kendo-white-grid approval-grid group-approval-grid grid-spacing-left-3"
                        [selectable]="selectableSettings"
                        (cellClick)="onRowSelection($event)"
                        kendoGridSelectBy="oid"
                        [(selectedKeys)]="item.selectedRows"
                        (selectedKeysChange)="onSelectionChange(item.group)">
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="propertyName"
                                 title="{{'raci.participantsAssignment.propertyName' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="municipally"
                                 title="{{'raci.participantsAssignment.titleMunicipally' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="address"
                                 title="{{'raci.participantsAssignment.titleAddress' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="argusPropAssetId"
                                 title="{{'raci.participantsAssignment.argusPropAssetId' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="dataStatus"
                                 title="{{'raci.participantsAssignment.dataStatus' | translate}}"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div>{{dataItem.dataStatus }}</div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="lastDataSync"
                                 title="{{'raci.participantsAssignment.lastDataSync' | translate}}"
                                 [width]="auto" >
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.lastDataSync | date: 'dd/MM/YYYY HH:mm'}}
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
